import React, { useContext, useEffect, useState } from "react";
import Sidebar from "../../components/Genericos/Sidebar/Sidebar";
import HeaderbarHome from "../../components/Genericos/HeaderbarHome/HeaderbarHome";
import MultitabHome from "../../components/Turnos/MultitabHome/MultitabHome";
import { multiTabsData } from "../../../global/utils/multiTabData";
import { useHistory } from "react-router";
import TituloSaludo from "../../components/Genericos/TituloSaludo/TituloSaludo";
import { PortalContext } from "../../context/Provider";
import Modal from "../../components/Genericos/Modal/Modal";
import ToasterV2 from "../../../global/component/Genericos/Toaster/ToasterV2";
import BurguerMobile from "../../components/Genericos/BurguerMobile/BurguerMobile";
import BuscadorEstudio from "../../components/Turnos/BuscadorEstudio/BuscadorEstudio";
import MultitabMobile from "../../components/Turnos/MultitabMobile/MultitabMobile";
import {
  laboGrupo,
  wsGetLaboCentros,
} from "../../context/Actions/laboGrupo/laboGrupo";
import { estudioGrupo, filtrarEstudioGrupoPorEdad } from "../../context/Actions/estudioGrupo/estudioGrupo";
import "./Estudios.css";
import {
  LimpiarSelectE,
  LimpiarSelectGlobal,
  SelectUserE,
  SelectUserGlobal,
} from "../../context/Actions/DropDownFamiliares/selectFamiliares";
import { hideModal, showModal } from "../../context/Actions/modal/modal";
import Loading from "../../components/Genericos/Loading/Loading";
import { finalizaTurnosDisponibles } from "../../context/Actions/turnos/turnosDisponibles";
import { logoutEstudiosTurnos } from "../../context/Actions/turnos/estudioTurnos";
import { GlobalContext } from "../../../global/context/Provider";
import routes from "_+_Portal/routes/listRoutes";
import BuscadorTurnos from "../BuscadorTurnos/BuscadorTurnos";
import {
  finalizaEdicion,
  logoutPacientePerfil,
  wsGetDatosPaciente,
  wsPostEditarPaciente,
} from "_+_Portal/context/Actions/paciente/paciente";
import { wsPostOrdenAsistencia } from "_+_Portal/context/Actions/ordenEstudio/ordenEstudio";
import { showToaster } from "global/context/action/toaster/toaster";
import { wsGetTextos } from "_+_Portal/context/Actions/textos/textos";
import { pageContainerVariants } from "global/utils/cardAnimation";
import { motion } from "framer-motion";
import HeaderTitle from "_+_Portal/components/Genericos/HeaderTitle/HeaderTitle";
import BottomNavbar from "_+_Portal/components/Genericos/BottomNavbar/BottomNavbar";
import "_+_Portal/components/Genericos/BottomNavbar/BottomNavbar.css";

const Estudios = () => {
  const history = useHistory();
  const {
    estudioGrupoDispatch,
    estudioGrupoState,
    modalState,
    laboGrupoDispatch,
    laboGrupoState,
    modalDispatch,
    selectDropDownState,
    selectDropDownDispatch,
    turnosDisponiblesDispatch,
    turnosDisponiblesState,
    estudioTurnosDispatch,
    pacienteState,
    pacienteDispatch,
    ordenEstudioDispatch,
    textosDispatch,
    listaFamiliaresState,
  } = useContext(PortalContext);
  // Nuevo contexto
  const { authState, toasterState, configState, toasterDispatch } =
    useContext(GlobalContext);

  const [showBurguerMobile, setShowBurguerMobile] = useState(false);
  const [flgBtnEnvio, setFlgBtnEnvio] = useState(false);
  const [disponibilidadFlg, setDisponibilidadFlg] = useState(false);
  const [frenteOrdenFlg, setFrenteOrdenFlg] = useState(false);
  const [loadingOrden, setLoadingOrden] = useState(false);
  const [observacionOrden, setObservacionOrden] = useState("");
  const [tabsData, setTabsData] = useState(multiTabsData);
  let config = localStorage.getItem("config");
  let opcEnviarOrdenSinTurno = JSON.parse(config).opcEnviarOrdenSinTurno;
  const widthWindow = window.innerWidth;
  const esMobile = widthWindow <= 768;

  const onShowBurguerHandle = () => {
    setShowBurguerMobile(true);
  };

  const onCloseBurguerMobile = (type) => {
    if (type === "open") setShowBurguerMobile(true);
    else setShowBurguerMobile(false);
  };

  const onClickMultitabHome = (e) => {
    if (configState.config.data.opcBuscadorTurnos) {
      const index = routes.findIndex((objeto) => objeto.id === 30);
      if (index === -1) {
        routes.push({
          id: 30,
          path: "/buscadorTurnos",
          component: BuscadorTurnos,
          title: "Buscador Turnos",
          needsAuth: false,
        });
      }
    }
    history.push(e.path);
  };

  //repetir en las paginas para tener los datos de los grupos
  useEffect(() => {
    if (configState.config.data !== null) {
      if (estudioGrupoState.estudioGrupo.data === null) {
        estudioGrupo(authState?.auth?.data?.paciente)(estudioGrupoDispatch);
      }
      if (
        laboGrupoState.laboGrupo.data === null &&
        configState.config.data.opcLaboratorio
      ) {
        laboGrupo()(laboGrupoDispatch);
      }
      if (
        laboGrupoState.laboGrupo.centros === null &&
        configState.config.data.opcLaboratorio
      ) {
        wsGetLaboCentros()(laboGrupoDispatch);
      }
      if (
        turnosDisponiblesState.turnosDisponibles.turnosData.volverOrigen ===
        "ESTUDIOS"
      ) {
        logoutEstudiosTurnos()(estudioTurnosDispatch);
        finalizaTurnosDisponibles()(turnosDisponiblesDispatch);
      }
    }
    //eslint-disable-next-line
  }, [configState.config.data]);

  // ONCHANGE DE LOS DROPDOWNS
  const onChangeMultitabMobile = (e) => {
    const dataOriginal = estudioGrupoState.estudioGrupo.dataOriginal;
    
    if (e !== "") {
      if (
        e.id &&
        e.id !== authState.auth.data.paciente.codigo &&
        e.manejoTurnos
      ) {
        SelectUserE({ id: e.id, paciente: e.paciente })(selectDropDownDispatch);
        SelectUserGlobal({ id: e.id, paciente: e.paciente })(
          selectDropDownDispatch,
        );
        filtrarEstudioGrupoPorEdad(dataOriginal, e.paciente)(estudioGrupoDispatch);
      } else if (e.id !== authState.auth.data.paciente.codigo) {
        showToaster(
          {
            texto: "No posees permisos para gestionar turnos de este familiar.",
            tipo: "warning",
          },
          "centroArriba",
        )(toasterDispatch);

        LimpiarSelectE()(selectDropDownDispatch);
        LimpiarSelectGlobal()(selectDropDownDispatch);
      } else {
        LimpiarSelectE()(selectDropDownDispatch);
        LimpiarSelectGlobal()(selectDropDownDispatch);
        filtrarEstudioGrupoPorEdad(dataOriginal, authState?.auth?.data?.paciente)(estudioGrupoDispatch);
      }
    } else {
      LimpiarSelectE()(selectDropDownDispatch);
    }
  };
  ////////////// ASISTENCIA //////////////
  const showModalEnviarOrden = () => {
    if (
      selectDropDownState.selectDropDown.selectGlobal.pacienteElegido === false
    ) {
      wsGetDatosPaciente()(pacienteDispatch);
    } else {
      wsGetDatosPaciente(
        selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id,
      )(pacienteDispatch);
    }
    setFlgBtnEnvio(true);
  };

  useEffect(() => {
    if (
      pacienteState.paciente.datosActualizados !== null &&
      pacienteState.paciente.datosActualizados !== undefined &&
      flgBtnEnvio
    ) {
      showModal(
        "Genericos/EnviarOrden/EnviarOrden",
        {
          subirOrden: showFrenteOrden,
          dissmiss: dissmissOrden,
        },
        [],
        "centro",
        true,
      )(modalDispatch);
    }
  }, [pacienteState.paciente.datosActualizados, flgBtnEnvio]);

  useEffect(() => {
    if (disponibilidadFlg) {
      showModal(
        "Turnos/DiasDisponibles/DiasDisponibles",
        {
          titulo: "Disponibilidad para toma de turno",
          onHandleDiasDisponibles: setearDiasDisponibles,
          dissmiss: dissmiss,
        },
        [],
        "centro",
        true,
      )(modalDispatch);
      setDisponibilidadFlg(false);
    }
  }, [disponibilidadFlg]);

  useEffect(() => {
    if (frenteOrdenFlg) {
      showModal(
        "Genericos/FrenteOrden/FrenteOrden",
        {
          finalizarProceso: finalizarProceso,
          dissmiss: dissmiss,
        },
        [],
        "centro",
        true,
      )(modalDispatch);
      setFrenteOrdenFlg(false);
    }
  }, [frenteOrdenFlg]);

  useEffect(() => {
    //complemento textos siempre lo ultimo
    wsGetTextos()(textosDispatch);
  }, []);

  // Setear familiar desde URL (hash con parámetro familiar)
  useEffect(() => {
    const familiarDNI = sessionStorage.getItem("familiarHash");

    if (
      familiarDNI &&
      listaFamiliaresState.listaFamiliares.data &&
      !selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
    ) {
      const familiarEncontrado = listaFamiliaresState.listaFamiliares.data.find(
        (fam) => fam.paciente?.nro_documento === familiarDNI,
      );

      if (familiarEncontrado) {
        if (familiarEncontrado.tipoDerecho?.manejoTurnos) {
          // Setear el familiar en el contexto
          SelectUserE({
            id: familiarEncontrado.id,
            paciente: familiarEncontrado.paciente,
          })(selectDropDownDispatch);
          SelectUserGlobal({
            id: familiarEncontrado.id,
            paciente: familiarEncontrado.paciente,
          })(selectDropDownDispatch);
          // Filtrar grupos de estudio por edad del familiar
          filtrarEstudioGrupoPorEdad(
            estudioGrupoState.estudioGrupo.dataOriginal,
            familiarEncontrado.paciente
          )(estudioGrupoDispatch);

          // Limpiar sessionStorage después de usar
          sessionStorage.removeItem("familiarHash");
        } else {
          // Familiar sin permisos
          showToaster(
            {
              texto: "El familiar no tiene permisos para gestionar turnos.",
              tipo: "warning",
            },
            "centroArriba",
          )(toasterDispatch);
          sessionStorage.removeItem("familiarHash");
        }
      } else {
        // Familiar no encontrado
        showToaster(
          {
            texto: "No se encontró el familiar especificado.",
            tipo: "warning",
          },
          "centroArriba",
        )(toasterDispatch);
        sessionStorage.removeItem("familiarHash");
      }
    }
  }, [listaFamiliaresState.listaFamiliares.data]);

  const showFrenteOrden = (e) => {
    finalizaEdicion()(pacienteDispatch);
    // Si no se edito ningun dato paso directamente a la subida de orden
    // sin hacer el post de datos
    if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
      if (
        e.email ===
          selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
            .paciente.email &&
        e.telefono_movil ===
          selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
            .paciente.telefono_movil
      ) {
        dissmiss();
        setDisponibilidadFlg(true);
      } else {
        wsPostEditarPaciente(
          e,
          pacienteState.paciente.userSelect.pacienteSeleccionado.id,
        )(pacienteDispatch);
      }
    } else {
      if (
        e.email === authState.auth.data.paciente.email &&
        e.telefono_movil === authState.auth.data.paciente.telefono_movil
      ) {
        dissmiss();
        setDisponibilidadFlg(true);
      } else {
        wsPostEditarPaciente(e)(pacienteDispatch);
      }
    }
  };

  const dissmiss = () => {
    hideModal()(modalDispatch);
    logoutEstudiosTurnos()(estudioTurnosDispatch);
  };

  const dissmissOrden = () => {
    logoutPacientePerfil()(pacienteDispatch);
    hideModal()(modalDispatch);
  };

  const setearDiasDisponibles = (dias, horarios) => {
    dissmiss();
    let diasDisp = dias.filter((item) => item.checked === true);
    let descripcionesDias = diasDisp.map((item) => item.descripcion);
    let diasConcatenados = descripcionesDias.join(", ");

    let horariosDisp = horarios.filter((item) => item.checked === true);
    let descripcionesHorarios = horariosDisp.map((item) => item.descripcion);
    let horariosConcatenados = descripcionesHorarios.join(", ");

    let arrayDisponible = {
      Dias: diasConcatenados,
      Horarios: horariosConcatenados,
    };
    setObservacionOrden(arrayDisponible);
    setFrenteOrdenFlg(true);
  };

  const finalizarProceso = (arrayImg) => {
    setLoadingOrden(true);
    let arrayOrdenes = [];
    for (let i = 0; i < arrayImg.length; i++) {
      const element = arrayImg[i];
      if (element.idRemoto === undefined) {
        element.idRemoto =
          selectDropDownState.selectDropDown.selectGlobal.pacienteElegido ===
          false
            ? authState.auth.data.paciente.codigo
            : selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
                .id;
      }
      element.autocheck = false;
      element.observacion = JSON.stringify(observacionOrden);
      arrayOrdenes.push(element);
    }
    wsPostOrdenAsistencia(arrayOrdenes, cerrarModal)(ordenEstudioDispatch);
  };

  const cerrarModal = (resp) => {
    if (!resp) {
      showToaster(
        {
          texto: "Error al subir la orden.",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
    } else {
      dissmiss();
      showModal(
        "Genericos/AsistenciaModal/AsistenciaModal",
        {
          actualizarPagina: actualizarPagina,
          dissmiss: dissmiss,
        },
        [],
        "centro",
        true,
      )(modalDispatch);
    }
    setLoadingOrden(false);
  };

  const actualizarPagina = () => {
    window.location.reload();
  };
  ////////////// ASISTENCIA //////////////

  useEffect(() => {
    if (configState.config.data !== null) {
      let tabsAux = tabsData;
      if (configState.config.data.opcLaboratorio === false) {
        tabsAux = tabsAux.filter((i) => i.id !== 2);
      }
      if (configState.config.data.opcRecetaDigital === false) {
        tabsAux = tabsAux.filter((i) => i.id !== 3);
      }
      if (
        configState.config.data.opcRecetaDigital === false &&
        configState.config.data.opcLaboratorio === false &&
        configState.config.data.opcBuscadorTurnos === false
      ) {
        tabsAux = tabsAux.filter((i) => i.id !== 3 && i.id !== 2);
      }
      if (configState.config.data.opcBuscadorTurnos) {
        tabsAux = tabsAux.filter((i) => i.id !== 0 && i.id !== 1 && i.id !== 2);
      } else {
        tabsAux = tabsAux.filter((i) => i.id !== 5);
      }
      setTabsData(tabsAux);
    }
  }, [configState.config.data]);

  return (
    <React.Fragment>
      {modalState.modal.show && <Modal />}
      {toasterState.toaster.show && <ToasterV2 />}
      {/* HEADER BAR DE PORTAL  */}
      <BurguerMobile
        onCloseBurguerMobile={onCloseBurguerMobile}
        showBurguerMobile={showBurguerMobile}
      />
      <Loading
        dataLoading={
          estudioGrupoState.estudioGrupo.loading ||
          pacienteState.paciente.loading ||
          loadingOrden ||
          estudioGrupoState.estudioGrupo.data === null
        }
        color="c-white"
        descripcion={
          (estudioGrupoState.estudioGrupo.loading && "Cargando estudios...") ||
          (pacienteState.paciente.loading && "Cargando datos...") ||
          (loadingOrden && "Subiendo orden...") ||
          (estudioGrupoState.estudioGrupo.data === null &&
            "Cargando estudios...")
        }
      />
      <HeaderbarHome onShowBurguerHandle={onShowBurguerHandle} />
      <HeaderTitle title={"Estudios"} />
      {/* <MultitabMobile
        posicionMultitab={1}
        onChangeMultitabMobile={onChangeMultitabMobile}
        type={"ESTUDIOS"}
      /> */}
      <motion.div
        variants={pageContainerVariants(esMobile)}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
        {estudioGrupoState.estudioGrupo.data && (
          <div className="ptur-bodyContainer-Estudios with-bottom-navbar">
            <Sidebar />
            <div className="ptur-estudios-container">
              <TituloSaludo />
              <div className="ptur-estudios-buscador">
                <MultitabHome tabs={tabsData} onClick={onClickMultitabHome} />
                <BuscadorEstudio
                  onChangeMultitabMobile={onChangeMultitabMobile}
                />
                {opcEnviarOrdenSinTurno && (
                  <div className="ptur-estudios-asistenciaBox">
                    <div className="ptur-estudios-textoAsistencia">
                      <p className="c-latex10 rb18m">
                        ¿No encontrás lo que buscas o no entendes la letra de tu
                        médico?
                      </p>
                      <p className="c-latex10 rb14l subTxt">
                        Enviá tu orden médica ahora
                      </p>
                    </div>
                    <button
                      className="ptur-estudios-asistenciaBtn bgc-primary c-white rb16m"
                      onClick={showModalEnviarOrden}
                    >
                      Enviar orden médica
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </motion.div>

      {/* Bottom Navbar - Solo visible en móviles */}
      {esMobile && <BottomNavbar />}
    </React.Fragment>
  );
};
export default Estudios;
